import React from 'react'
import wechatPay from '../../static/wechat-qrcode.jpg'
import wechatAccount from '../../static/wechat_public_account.jpeg'
import bookPic from '../../static/hellosleep-book.jpg'

export default class Follow extends React.Component {
  render() {
    return (
      <div>
        <div className="columns is-centered">
          <div className="column has-text-centered">
            <a class="has-text-weight-bold" href="http://www.hellosleep.net/blog/6336edf75dcaa3173ab8a3a6">《乔装的失眠》</a>
            <p className="has-text-success">失眠者必读</p>
            <img
              alt="乔装的失眠"
              src={bookPic}
              css={{
                height: "auto !important",
                width: "250px !important"
              }}
            />
          </div>
        </div>
        <div className="columns is-centered">
          <div className="column has-text-centered">
            <div className="has-text-weight-bold">捐助睡吧</div>
            <p className="has-text-success">睡吧有你更温暖</p>
            <img
              alt="捐助睡吧"
              src={wechatPay}
              css={{
                height: "auto !important",
                width: "250px !important"
              }}
            />
          </div>
        </div>
        <div className="columns is-centered">
          <div className="column has-text-centered">
            <div className="has-text-weight-bold">关注睡吧公众号</div>
            <img
              alt="关注睡吧公众号"
              src={wechatAccount}
              css={{
                height: "auto !important",
                width: "250px !important"
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}
